import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PurchaseOrderService } from '../proxy/controlling/controllers/purchase-order.service';
import { StorageLocationService } from '../proxy/controlling/controllers/storage-location.service';
import { SapPlantService } from '../proxy/controlling/controllers/sap-plant.service';
import { ServiceMasterService } from '../proxy/controlling/controllers/service-master.service';
import { UnitOfMeasureService, ConsumableService } from '@general/proxy/general/controllers/';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Controlling');

export const PURCHASEORDERDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('lineItem', 'Entity.PurchaseOrderDetail.LineItem')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.PurchaseOrderDetail.Consumable', ConsumableService)
    .display('name')
    .sortBy('consumable.name')
    .build(),
  FieldBuilder
    .number('quantity', 'Entity.PurchaseOrderDetail.Quantity')
    .required()
    .decimal(2,20)
    .build(),
  FieldBuilder
    .number('price', 'Entity.PurchaseOrderDetail.Price')
    .required()
    .decimal(2,20)
    .build(),
  FieldBuilder
    .text('materialType', 'Entity.PurchaseOrderDetail.MaterialType')
    .minLength(2)
    .maxLength(35)
    .build(),
  FieldBuilder
    .text('materialGroup', 'Entity.PurchaseOrderDetail.MaterialGroup')
    .required()
    .minLength(2)
    .maxLength(9)
    .build(),
  FieldBuilder
    .text('materialCode', 'Entity.PurchaseOrderDetail.MaterialCode')
    .minLength(2)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('shortText', 'Entity.PurchaseOrderDetail.ShortText')
    .required()
    .minLength(2)
    .maxLength(70)
    .build(),
  FieldBuilder
    .foreignKey('serviceMasterId', 'Entity.ServiceMaster', ServiceMasterService)
    .displayFromNested('serviceMaster.name')
    .sortBy('serviceMaster.name')
    .build(),
  FieldBuilder
    .text('status', 'Entity.PurchaseOrderDetail.Status')
    .minLength(1)
    .maxLength(3)
    .build(),
  FieldBuilder
    .date('deliveryDate', 'Entity.PurchaseOrderDetail.DeliveryDate')
    .build(),
  FieldBuilder
    .number('balance', 'Entity.PurchaseOrderDetail.Balance')
    .decimal(2,20)
    .build(),
  FieldBuilder 
    .foreignKey('depositLocationId', 'Entity.PurchaseOrderDetail.DepositLocation', LocationService)
    .queryFilter({ locationTypeEntityName: 'Deposit' })
    .displayFromNested('depositLocation.name')
    .sortBy('depositLocation.name')
    .build(),
  FieldBuilder
    .foreignKey('purchaseOrderId', 'Entity.PurchaseOrder', PurchaseOrderService)
    .required()
    .displayFromNested('purchaseOrder.number')
    .sortBy('purchaseOrder.number')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('storageLocationId', 'Entity.PurchaseOrderDetail.StorageLocation', StorageLocationService)
    .displayFromNested('storageLocation.name')
    .sortBy('storageLocation.name')
    .build(),
  FieldBuilder
    .foreignKey('sapPlantId', 'Entity.Plant', SapPlantService)
    .required()
    .displayFromNested('sapPlant.name')
    .sortBy('sapPlant.name')
    .build(),
  FieldBuilder
    .foreignKey('unitOfMeasureId', 'Entity.UnitOfMeasure', UnitOfMeasureService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const PURCHASEORDERDETAIL_CONFIG = {
  entityName: 'PurchaseOrderDetail',
  localizationKey: 'Controlling::Entity.PurchaseOrderDetail',
  fields: PURCHASEORDERDETAIL_FIELDS,
  permission: 'ControllingSap.PurchaseOrderDetails',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
